<template>
  <div class="cardLine color_999">
    <div class="fs12 color_333 flex space-between">
      <p class="fs13">{{info.drugName}}</p>
      <P class="color_666">{{info.drugSpecification}}</P>
<!--      <p class="fee_color3">￥{{info.drugUnitPrice/100||info.price/100}}</p>-->
    </div>
    <div class="space-between flex">
      <p class="fs12">{{info.drugOrigin}}</p>
      <p class="color_main flex0">x{{info.amount}}{{info.drugUnit}}</p>
    </div>
    <div class="flex color_333 fs12">
      <p class="pr10">{{info.admission}} {{info.dosage}}{{info.dosageUnit}}/次</p>
      <p>{{info.frequencyName}}</p>
      <p class="flex0" v-if="info.useDays">用药{{info.useDays}}天</p>
    </div>
    <p v-if="info.remarks" class="fs12">补充说明：{{info.remarks}}</p>
    <p class="mt15" :class="[isSolid?'solid':'dash']"></p>
  </div>
</template>

<script>
  export default {
    name: "renewal-drugs-card-line",
    props:{
      info: Object,
      isSolid:{
        default: false,
        type: Boolean
      },
    },
  }
</script>

<style scoped lang="scss">
  .cardLine{
    min-height: 58px;
  }
  .solid{
    border-top: 1px solid #f1f1f1;
    height: 7px;
  }
  .dash {
    border-top: 1px dashed #f1f1f1;
    height: 7px;
  }
</style>
